var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginEllipse3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 171,
    viewBox: "0 0 169 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168 85.5C168 132.179 130.605 170 84.5 170C38.3953 170 1 132.179 1 85.5C1 38.8208 38.3953 1 84.5 1C130.605 1 168 38.8208 168 85.5Z",
    stroke: "#F9A826",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginEllipse3);
export default __webpack_public_path__ + "static/media/login-ellipse-3.f7f7f035999bf3b8709cb673c8be82ca.svg";
export { ForwardRef as ReactComponent };